import { render, staticRenderFns } from "./DictionaryAcceptanceWordsIndex.vue?vue&type=template&id=d4a8e972&scoped=true&"
import script from "./DictionaryAcceptanceWordsIndex.vue?vue&type=script&lang=js&"
export * from "./DictionaryAcceptanceWordsIndex.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryAcceptanceWordsIndex.vue?vue&type=style&index=0&id=d4a8e972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a8e972",
  null
  
)

export default component.exports